import { Navigate } from 'react-router-dom';

const NotFound = () => {
    return <Navigate to="/not-found" replace={true} />;
}

export default NotFound;